export const STORE_VAL: any = {

    personal_details: 'personalDetails',
    quote_result: 'quoteResult',
    registration_details: 'registrationDetails',
    application_data_response: 'applicationDataResponse',
    pension_savings: 'pensionSavings',
    your_product_application: 'yourProductApplication',
    beneficiary_details: 'beneficiaryDetails',
    your_dependant_details: 'yourDependantDetails',
    dependant_doctor_details: 'dependantDoctorDetails',
    annuitant_doctor_details: 'annuitantDoctorDetails',
    your_personal_details: 'yourPersonalDetails',
    clear_apply: 'clearApply',
    ref_no: 'refno',
    bank_details: 'bankDetails',
    before_start: 'beforeStart',
    dependant_details: 'dependantDetails',
    your_pension: 'yourpension',
    quote_capture: 'quoteCapture',
    product_choice: 'productChoice',
    req_quote_calculation: 'reqQuoteCalculation',
    quote_calculation: 'quoteCalculation',
    lifestyle: 'lifeStyle',
    medical_conditon: 'medicalCondtion',
    loggedin_detail: 'loggedinDetail',
    quote_playback_risk_warning: 'quotePlaybackRiskWarning',
    card_Refresh: 'cardRefresh',
    underwriting_data_ho: 'underwritingDataHO',
    initial_question: 'initialQuestion',
    guidance_and_advice: 'guidanceAndAdvice',
    your_lump_sum_allowances:'yourLumpSumAllowances'
};